<template>
  <Row :gutter="24">
    <Col v-bind="grid" class="ivu-mb">
    <div class="card card-animate">
      <div class="card-body">
        <div class="avatar-sm float-right">
          <span class="avatar-title bg-soft-primary rounded-circle">
            <span class="iconfont icon-quanbu2"></span>
          </span>
        </div>
        <h6 class="text-muted text-uppercase mt-0">今日全部订单</h6>
        <h3 class="my-3">
          <span v-if="data.today_order >=0">{{data.today_order}}</span>
          <Icon custom="iconfont icon-jiazai" v-else />

        </h3>
        <span class="badge badge-soft-primary mr-1">
          {{isNaN(data1)?'--':data1}}%

        </span>
        <span class="text-muted">较昨天</span>
      </div>
    </div>
    </Col>
    <Col v-bind="grid" class="ivu-mb">
    <div class="card card-animate">
      <div class="card-body">
        <div class="avatar-sm float-right">
          <span class="avatar-title bg-soft-primary rounded-circle">
            <span class="iconfont icon-success-circle"></span>
          </span>
        </div>
        <h6 class="text-muted text-uppercase mt-0">今日成交订单</h6>
        <h3 class="my-3">
          <span v-if="data.today_seccess_order >=0">{{data.today_seccess_order}}</span>
          <Icon custom="iconfont icon-jiazai" v-else />
        </h3>
        <span class="badge badge-soft-primary mr-1">
          {{isNaN(data2)?'--':data2}}%
        </span>
        <span class="text-muted">较昨天</span>
      </div>
    </div>
    </Col>
    <Col v-bind="grid" class="ivu-mb">
    <div class="card card-animate">
      <div class="card-body">
        <div class="avatar-sm float-right">
          <span class="avatar-title bg-soft-primary rounded-circle">
            <span class="iconfont icon-jine"></span>
          </span>
        </div>
        <h6 class="text-muted text-uppercase mt-0">今日成交额</h6>
        <h3 class="my-3">
          <span v-if="data.today_seccess_money >=0">{{data.today_seccess_money}}</span>
          <Icon custom="iconfont icon-jiazai" v-else />
        </h3>
        <span class="badge badge-soft-primary mr-1">
          {{isNaN(data3)?'--':data3}}%
        </span>
        <span class="text-muted">较昨天</span>
      </div>
    </div>
    </Col>
    <Col v-bind="grid" class="ivu-mb">
    <div class="card card-animate">
      <div class="card-body">
        <div class="avatar-sm float-right">
          <span class="avatar-title bg-soft-primary rounded-circle">
            <span class="iconfont icon-leijishouyi"></span>
          </span>
        </div>
        <h6 class="text-muted text-uppercase mt-0">累计成交额</h6>
        <h3 class="my-3">
          <span v-if="data.all_seccess_money >=0">{{data.all_seccess_money}}</span>
          <Icon custom="iconfont icon-jiazai" v-else />
        </h3>
        <span class="badge badge-soft-primary mr-1">
          
          {{(data.success_order/data.all_order*100).toFixed(0)}}%
        </span>
        <span class="text-muted">成交率</span>
      </div>
    </div>
    </Col>
  </Row>
</template>
<script>
  import {
    getHome
  } from "@/api/admin";
  export default {
    data() {
      return {
        grid: {
          xl: 6,
          lg: 12,
          md: 12,
          sm: 12,
          xs: 24,
        },
        data: {},
        data1: "",
        data2: "",
        data3: "",
      };
    },
    created() {
      this._getHome()
    },
    methods: {
      _getHome() {
        getHome().then(res => {
          this.data = res.data
          this.data1 = ((res.data.today_order - res.data.yesterday_order) / res.data.yesterday_order * 100).toFixed(
            0)
          this.data2 = ((res.data.today_seccess_order - res.data.yesterday_seccess_order) / res.data.yesterday_seccess_order *
            100).toFixed(0)
          this.data3 = ((res.data.today_seccess_money - res.data.yesterday_seccess_money) / res.data.yesterday_seccess_money *
            100).toFixed(0)
        })
      }
    },
    mounted() {

    },
  };
</script>
<style scoped>
  .avatar-title .iconfont {
    font-size: 28px;
    color: #2d8cf0;
  }
</style>